import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  archiveBatch: {
    defaultMessage: 'Archive Batch',
    id: 'PWBu4u',
    description: 'labelBatch.archiveBatch',
  },
  otherDocs: {
    defaultMessage: 'Other Docs',
    id: 'fRcMbz',
    description: 'labelBatch.otherDocs',
  },
  otherForms: {
    defaultMessage: 'Other Forms',
    id: 'QuNnSf',
    description: 'labelBatch.otherForms',
  },
  printLabels: {
    defaultMessage: 'Print Labels',
    id: 'wFO7d5',
    description: 'labelBatch.printLabels',
  },
  printOrderSummary: {
    defaultMessage: 'Print Order Summary',
    id: 'z9weUJ',
    description: 'labelBatch.printOrderSummary',
  },
  printPackingSlips: {
    defaultMessage: 'Print Packing Slips',
    id: '+6wZy3',
    description: 'labelBatch.printPackingSlips',
  },
  printPickList: {
    defaultMessage: 'Print Pick List',
    id: 'joRn2M',
    description: 'labelBatch.printPickList',
  },
  printShipmentManifest: {
    defaultMessage: 'Print Shipment Manifest',
    id: 'kvamvY',
    description: 'labelBatch.printShipmentManifest',
  },
});
